/* global axios */
/* SolNow — comentarios de un ticket (anidados bajo el ticket) */
import ApiClient from './ApiClient';

class TicketCommentsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  getComments(ticketId) {
    return axios.get(`${this.url}/${ticketId}/comments`);
  }

  createComment(ticketId, content) {
    return axios.post(`${this.url}/${ticketId}/comments`, {
      ticket_comment: { content },
    });
  }

  deleteComment(ticketId, id) {
    return axios.delete(`${this.url}/${ticketId}/comments/${id}`);
  }
}

export default new TicketCommentsAPI();
